import { gql } from '@apollo/client';

const metadataOperationResultFragment = gql`
  fragment MetadataOperationResultFields on OperationResult {
    Success
    Errors {
      Code
      Message
      Metadata {
        Key
        Value
      }
    }
  }
`;

export default metadataOperationResultFragment;
